export const noSpaces = (inputString: string): string => {
  return inputString.split(' ').join('').toLowerCase();
};
